import * as React from 'react';
import { Provider } from 'react-redux';
import BootstrapContainer from './AppStructure/bootstrap_container';
import PortalContainer from './AppStructure/portal_container';
import TeamNotFound from './TeamNotFound/team_not_found';
import { Router, Route } from 'react-router-dom';
import { PORTAL_ROUTE_PREFIX } from '../constants/values';
import { createBrowserHistory } from 'history';
import { PortalDynamicValuesProvider } from './DynamicValues';
import { PortalDVSClientProvider, DVSLoader } from './DV2';
var PortalProvider = function (_a) {
    var _b = _a.reduxStore, reduxStore = _b === void 0 ? {} : _b;
    var history = createBrowserHistory();
    return (React.createElement(Provider, { store: reduxStore },
        React.createElement(PortalDynamicValuesProvider, null,
            React.createElement(PortalDVSClientProvider, null,
                React.createElement(DVSLoader, null,
                    React.createElement(Router, { history: history },
                        React.createElement(BootstrapContainer, { protectedRoutes: [
                                React.createElement(Route, { exact: true, path: PORTAL_ROUTE_PREFIX + "/team-not-found", component: TeamNotFound }),
                                React.createElement(Route, { component: PortalContainer }),
                            ] })))))));
};
export default PortalProvider;
